/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css } from "@panda/css";
import { VStack } from "@panda/jsx";
import { CosmosDesc } from "../title-desc-stack";
import { CosmosButton, CosmosTable, CosmosText, CosmosTextVariantEnum } from "@components/elements/atoms";
import { useMessages } from "@epic-mw/i18n";

export interface ArchivedVersionTableItemProps {
	title?: string | null;
	desc?: string | null;
	downloadUrl?: string | null;
	os?: string | null;
}

export const ArchivedVersionTableItem = ({
	title,
	desc,
	downloadUrl,
	os,
}: ArchivedVersionTableItemProps): React.JSX.Element | null => {
	const messages = useMessages();

	if (!title || !downloadUrl) return null;

	return (
		<CosmosTable.Row w="full">
			<CosmosTable.Cell>
				<VStack gap="eds.dimension.12" alignItems="flex-start">
					<CosmosText variant="paragraphLGBold" text={`${title} ${os ? `(${os})` : ""}`} />
					{desc ? (
						<CosmosDesc
							description={{
								html: desc,
								variant: CosmosTextVariantEnum.paragraphSM,
								color: "eds.text.secondary",
							}}
						/>
					) : null}
				</VStack>
			</CosmosTable.Cell>
			<CosmosTable.Cell
				alignItems="center"
				justifyContent="flex-end"
				className={css({
					display: "flex",
				})}
			>
				<CosmosButton
					href={downloadUrl}
					label={messages["epic.cosmos.plugins.download"]}
					variant="secondary"
					size="lg"
					name={title}
				/>
			</CosmosTable.Cell>
		</CosmosTable.Row>
	);
};
